import { store } from '../../../store';
import { addOption } from '../../../store/conversation/conversation.slice';

export const handleAddOption = (question) => {
  store.dispatch(addOption(question));
};
